import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../rootReducer'
import { CompletedStepType, ItineraryStepNumberType } from '@/src/types/itinerary'

interface ItineraryState {
    activeStep: ItineraryStepNumberType
    completedSteps: CompletedStepType
    validationErrors: {
        insurance: {
            termsAndConditions: boolean
        }
    }
}
const initialState: ItineraryState = {
    activeStep: 1,
    completedSteps: [],
    validationErrors: {
        insurance: {
            termsAndConditions: false
        }
    }
}
export const itinerarySlice = createSlice({
    name: 'itinerary',
    initialState,
    reducers: {
        setActiveStep: (state, action: PayloadAction<ItineraryStepNumberType>) => {
            state.activeStep = action.payload
        },
        addCompletedStep: (state, action: PayloadAction<ItineraryStepNumberType>) => {
            const stepToUpdate = action.payload
            const completedSteps = state.completedSteps
            if (!completedSteps.includes(stepToUpdate)) {
                state.completedSteps = [...completedSteps, stepToUpdate]
            }
        },
        removeCompletedStep: (state, action: PayloadAction<ItineraryStepNumberType>) => {
            const stepToUpdate = action.payload
            const completedSteps = state.completedSteps
            if (completedSteps.includes(stepToUpdate)) {
                state.completedSteps = completedSteps.filter(step => step !== stepToUpdate)
            }
        },
        setInsuranceTermsAndConditionsError: (state, action: PayloadAction<boolean>) => {
            state.validationErrors.insurance.termsAndConditions = action.payload
        }
    }
})

export const { setActiveStep, addCompletedStep, removeCompletedStep, setInsuranceTermsAndConditionsError } =
    itinerarySlice.actions
export const getActiveStep = (state: RootState) => state.itinerary.activeStep
export const getCompletedSteps = (state: RootState) => state.itinerary.completedSteps
export const getItineraryValidationErrors = (state: RootState) => state.itinerary.validationErrors

export default itinerarySlice.reducer
